import { cloneDeep } from 'lodash';

const openaiConfig = process.env;

export const websocketConnection = (session_id: string, content_id: string, message: string, onMessage: Function, param?: any) => {
  const websocket = new WebSocket(openaiConfig.REACT_APP_STREAM_WSS_END_POINT);
  let layoutItems = [];
  websocket.onopen = () => {
    websocket.send(
      JSON.stringify({
        action: 'WebsocketOpenaiEvent',
        url: 'query/meteor/retail',
        session_id,
        content_id,
        content: message,
        param: param,
        generate_answer: 'simple', // 'sql_agent'
      })
    );
  };

  websocket.onmessage = async (e) => {
    const data = JSON.parse(e.data);
    if (data.message === 'data sent.') {
      // skip
      return;
    }
    if (!data.type) {
      onMessage(null);
      return;
    }

    switch (data.type) {
      case 'LAYOUT':
        {
          layoutItems = data.data;
        }
        break;
      case 'DATA_TABLE':
        {
          const has = layoutItems.find((item) => {
            return item.component_id === 'table_' + data.component_id;
          });
          if (!has) {
            const item = {
              component_id: 'table_' + data.component_id,
              i: 'table_' + data.component_id,
              x: 0,
              y: 0,
              w: 24,
              h: 12,
              padding: '',
              margin: '',
              type: 'BasicTable',
              addBtnName: '',
              tableHeaderLevelCount: 1,
              tableColumns: {
                columns: [],
                tableType: 'Simple Table',
              },
              dataSource: {
                mockData: '',
                api: {
                  url: '',
                  mockLogic: '',
                },
              },
              tag: 'table',
            };
            layoutItems.push(item);
          }
          for (let index = 0; index < layoutItems.length; index++) {
            if (layoutItems[index].component_id === 'table_' + data.component_id) {
              if (!layoutItems[index].dataSource) {
                layoutItems[index].dataSource = { mockData: [] };
              }
              if (!layoutItems[index].tableColumns) {
                layoutItems[index].tableColumns = { columns: [] };
              }
              if (data.data.length > 0) {
                const tableData = JSON.stringify(data.data);
                layoutItems[index].dataSource.mockData = tableData;
                layoutItems[index].tableColumns.columns = Object.keys(data.data[0]).map((key, index) => {
                  return {
                    key: key,
                    title: key,
                    order: index,
                    dataIndex: key,
                  };
                });
              }
              break;
            }
          }
          layoutItems = cloneDeep(layoutItems);
        }
        break;
      case 'DATA_CHAT':
        {
          const has = layoutItems.find((item) => {
            return item.component_id === 'stream_chat_' + data.component_id;
          });
          if (!has) {
            const item = {
              name: 'StreamChatContainer',
              component_id: 'stream_chat_' + data.component_id,
              i: 'stream_chat_' + data.component_id,
              x: 0,
              y: 0,
              w: 24,
              h: 20,
              padding: '12px',
              type: 'StreamChatContainer',
              text: '',
            };
            layoutItems.push(item);
          }
          for (let index = 0; index < layoutItems.length; index++) {
            if (layoutItems[index].component_id === 'stream_chat_' + data.component_id) {
              layoutItems[index].text = data.data;
              break;
            }
          }
          layoutItems = cloneDeep(layoutItems);
        }
        break;
      case 'STREAM_CHAT':
        {
          const has = layoutItems.find((item) => {
            return item.component_id === 'stream_chat_' + data.component_id;
          });
          if (!has) {
            const item = {
              name: 'StreamChatContainer',
              component_id: 'stream_chat_' + data.component_id,
              i: 'stream_chat_' + data.component_id,
              x: 0,
              y: 0,
              w: 24,
              h: 20,
              padding: '12px',
              type: 'StreamChatContainer',
              text: '',
            };
            layoutItems.push(item);
          }
          for (let index = 0; index < layoutItems.length; index++) {
            if (layoutItems[index].component_id === 'stream_chat_' + data.component_id) {
              layoutItems[index].text += data.data;
              break;
            }
          }
          layoutItems = cloneDeep(layoutItems);
        }
        break;
      case 'DATA_CHART':
        {
          const item = {
            component_id: 'chart_1',
            i: 'chart_1',
            x: 0,
            y: 5,
            w: 12,
            h: 12,
            type: 'SeriesDataChart',
            chartOptions: {
              options: {
                tooltip: {
                  trigger: 'axis',
                  appendToBody: 'true',
                  className: 'overflow-all',
                  hideDelay: 0,
                },
                legend: { type: 'scroll', top: 0 },
                xAxis: { type: 'category', data: ['Aライン', 'Cライン', 'Dライン', 'Fライン', 'Sライン'] },
                yAxis: { type: 'value' },
                series: [],
              },
            },
          };
          for (let index = 0; index < layoutItems.length; index++) {
            if (data.sequence_id) {
              if (!layoutItems[index].chartOptions) {
                layoutItems[index].chartOptions = [];
              }
              layoutItems[index].chartOptions.push(data.data);
              break;
            }
            if (layoutItems[index].component_id === data.component_id) {
              layoutItems[index].chartOptions.options.series.push(data.data);
              break;
            }
          }
          layoutItems = cloneDeep(layoutItems);
        }
        break;
      case 'DATA_REPORT':
        {
          for (let index = 0; index < layoutItems.length; index++) {
            if (layoutItems[index].component_id === data.component_id) {
              layoutItems[index].data = data.data;
              break;
            }
          }
          layoutItems = cloneDeep(layoutItems);
        }
        break;
      case 'STREAM_STRATEGIC_OPTION':
        {
          for (let index = 0; index < layoutItems.length; index++) {
            if (layoutItems[index].component_id === data.component_id) {
              layoutItems[index].data = data.data;
              break;
            }
          }
          layoutItems = cloneDeep(layoutItems);
        }
        break;
      case 'DATA_STRATEGYOPTION':
        {
          if (layoutItems.length > 0) {
            layoutItems[0].data = data.data;
            layoutItems[0].option = data.option;
            layoutItems[0].type = data.type;
          } else {
            layoutItems.push({
              component_id: data.component_id,
              data: { ...data.data },
              option: data.option,
              type: data.type,
            });
          }
          layoutItems = cloneDeep(layoutItems);
        }
        break;
      case 'DATA_STRATEGYVECTOR':
        {
          if (layoutItems.length > 0) {
            layoutItems[0].data = data.data;
            layoutItems[0].option = data.option;
            layoutItems[0].type = data.type;
          } else {
            layoutItems.push({
              component_id: data.component_id,
              data: data.data,
              option: data.option,
              type: data.type,
            });
          }
          layoutItems = cloneDeep(layoutItems);
        }
        break;
      case 'DATA_KGI_KPI_FORECAST':
        {
          for (let index = 0; index < layoutItems.length; index++) {
            if (layoutItems[index].component_id === data.component_id) {
              layoutItems[index].data = data.data;
              break;
            }
          }
          layoutItems = cloneDeep(layoutItems);
        }
        break;
      case 'DATA_OPTION_SUMMARY':
        {
          for (let index = 0; index < layoutItems.length; index++) {
            if (layoutItems[index].component_id === data.component_id) {
              layoutItems[index].data = data.data;
              break;
            }
          }
          layoutItems = cloneDeep(layoutItems);
        }
        break;
      default:
        break;
    }
    setTimeout(() => {
      onMessage(layoutItems);
    }, 100);
  };

  websocket.onerror = (e: any) => {
    console.log('通信失敗: ' + JSON.stringify(e));
    websocket.close();
  };
};
